import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "staff-classes",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "staff-classes" */ "./components"),
      import(
        /* webpackChunkName: "staff-classes" */ "./modules/MapStaffToClassesModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;
      const key = importedModule1.NAME;
      injectReducer(store, {
        key,
        reducer,
      });
      return component;
    })
  ),
});
